// global computed groups (this.groups)
// global get specific group
// example: this.getGroup(idGroup)
export default {
  created () {
    // this.$store.dispatch('getGroups')
  },
  computed: {
    selectedGroups () {
      return this.$store.getters.selectedGroups
    },
    selectedGroup () {
      return this.$store.getters.selectedGroup
    },
    groups () {
      return this.$store.getters.groups
    }
  },
  methods: {
    getOneSelectedGroupId () {
      for (var i = 0; i < this.selectedGroups.length; i++) {
        return this.selectedGroups[i].idGroup
      }
      alert('Kon de groep niet bepalen, probeer opnieuw')
      return null
    },
    getGroup (id) {
      if (this.groups) {
        for (var i = 0; i < this.groups.length; i++) {
          if (this.groups[i].idGroup === id) {
            return this.groups[i]
          }
        }
      }
      return false
    }
  }
}
